export default __webpack_public_path__ + "static/media/ruffle_shape.13cd8f54.jpeg";